import * as actionTypes from "./constants";
import * as phases from "../../utils/helpers/phases";
import { removeHours } from "../../utils/helpers/date";
import { updateItemInArray } from "../../utils/helpers/immutable";
import moment from "moment";

const initialState = {
  phase: phases.INIT,
  data: [],
  date: removeHours(moment.utc()),
  selected: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.DECREMENT_DATE:
    case actionTypes.INCREMENT_DATE:
      return {
        ...state,
        date: action.date
      };
    case actionTypes.CREATE_OCCUPANCY_REQUEST:
    case actionTypes.EDIT_OCCUPANCY_REQUEST:
    case actionTypes.GET_OCCUPANCIES_REQUEST:
      return {
        ...state,
        phase: phases.LOADING
      };

    case actionTypes.CREATE_OCCUPANCY_REJECT:
    case actionTypes.EDIT_OCCUPANCY_REJECT:
    case actionTypes.GET_OCCUPANCIES_REJECT:
      return {
        ...state,
        phase: phases.ERROR
      };

    case actionTypes.GET_OCCUPANCIES_SUCCESS:
      return {
        ...state,
        phase: phases.LOADED,
        data: action.occupancies
      };

    case actionTypes.EDIT_OCCUPANCY_SUCCESS:
      return {
        ...state,
        phase: phases.LOADED,
        data: updateItemInArray(
          state.data.findIndex(
            occupancy => occupancy.roomId === action.occupancy.roomId
          ),
          action.occupancy,
          state.data
        )
      };

    case actionTypes.CREATE_OCCUPANCY_SUCCESS:
      return {
        ...state,
        phase: phases.LOADED,
        data: state.data.concat(action.occupancy)
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/rooms/occupancy/reducer.js